export const baseUrl = "https://api.rojinfelez.com";
